<app-header [forceLightBackground]="true"></app-header>
<div class="consumer-my-request">
  <div class="consumer-my-request--layout">
    <app-consumer-sidebar class="consumer-my-request--sidebar"></app-consumer-sidebar>
    <div class="consumer-my-request--content">
      <app-page-header></app-page-header>
      <app-my-request-shared></app-my-request-shared>
    </div>
  </div>
</div>
